import { Route } from '@angular/router';
import { LoginComponent } from './login.component';
import { ResetComponent } from './reset.component';
import { RequestResetComponent } from './request-reset.component';
import { RegisterConfirmComponent } from './register-confirm.component';
import { RegisterComponent } from './register.component';
import { GetStartedComponent } from './get-started.component';

export { AppAuthService, AuthUser } from './app-auth.service';
export { PasskeyService } from './passkey.service';
export type { Passkey } from './passkey.service';
export { authenticatedGuard } from './authenticated.guard';
export { dashboardCompaniesResolver, dashboardRedirectGuard } from './dashboard-redirect.guard';
export { notAuthenticatedGuard } from './not-authenticated.guard';

export default [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'get-started',
    component: GetStartedComponent,
  },
  {
    path: 'reset',
    component: RequestResetComponent,
  },
  {
    path: 'reset/:token',
    component: ResetComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'register/:token',
    component: RegisterConfirmComponent,
  },
] as Route[];
